// Mirrors roleAccess.js from the main FeraBio app.
// Each key maps to a list of nav-item labels to HIDE for that mode.
// "all" means nothing is hidden (full access).
const siteAccess = {
  dev: "all",
  public: [
    "Home",
    "Product",
    "Resources",
    "Use Cases",
    "About",
  ],
};

export default siteAccess;
